import { ICaseStudies } from './../../../../interfaces/home.interface';
import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ITestimonials } from 'src/app/interfaces/home.interface';
import { HomeService } from 'src/app/services/home/home.service';
import { UserService } from 'src/app/services/user/user.service';

@Component({
  selector: 'app-case-study',
  templateUrl: './case-studies.component.html',
  styleUrls: ['./case-studies.component.scss'],
})
export class CaseStudiesComponent implements OnInit {
  @Input() data: ICaseStudies[] = [];
  public caseStudies!: ICaseStudies[];
  constructor(
    private userService: UserService,
    private homeServiceRef: HomeService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    
  }
}
